<div class="newbgcolor">
    <div class="row mx-0">
        <div class="col">
            <div class="formbox flex-column">
                <div class="wccard w-100">
                    <p class="f-20 font-weight-600 text-black mb-4">Sign Up</p>
                    <p class="f-14 font-weight-normal text-black mb-5">Fill in the details to login into your account
                    </p>
                    <div>
                        <form [formGroup]="signupform">
                            <div class="row mr-2">
                                <div class="col">
                                    <div class="f-14 font-weight-400 mb-3"> First Name <span
                                            class="text-danger">*</span>
                                        <input data-testid="auto-app-self-signup-input-1" type="text" placeholder="Enter First Name"
                                            class="wc-form-control nobg mt-1" formControlName="firstName">
                                        <p *ngIf="signupform.get('firstName').errors?.required && (signupform['controls'].firstName.dirty || signupform['controls'].firstName.touched)"
                                            [ngClass]="['text-right','my-1','text-danger']"
                                            class="text-right my-1 text-danger">First Name is required</p>
                                        <p *ngIf="signupform['controls'].firstName.hasError('pattern')"
                                            class="text-danger f-12 pt-1">
                                            Special Character are not allowed!</p>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="f-14 font-weight-400 mb-3"> Last Name <span class="text-danger">*</span>
                                        <input data-testid="auto-app-self-signup-input-2" type="text" placeholder="Enter Last Name"
                                            class="wc-form-control nobg mt-1" formControlName="lastName">
                                        <p *ngIf="signupform.get('lastName').errors?.required && (signupform['controls'].lastName.dirty || signupform['controls'].lastName.touched)"
                                            [ngClass]="['text-right','my-1','text-danger']"
                                            class="text-right my-1 text-danger">Last Name is
                                            required</p>
                                        <p *ngIf="signupform['controls'].lastName.hasError('pattern')"
                                            class="text-danger f-12 pt-1">
                                            Special Character are not allowed!</p>
                                    </div>
                                </div>
                            </div>

                            <div class="row mr-4 mt-2">
                                <div class="f-14 font-weight-400 mb-3 col-md-6"> Company
                                    <input data-testid="auto-app-self-signup-input-3" type="text" placeholder="e.g. google, Tesla" class="wc-form-control nobg mt-1" formControlName="companyname"
                                        (input)="getDropdown($event, 'company')" [matAutocomplete]="company_auto">
                                
                                    <p *ngIf="signupform.get('companyname').errors?.required && (signupform['controls'].companyname.dirty || signupform['controls'].companyname.touched)"
                                        [ngClass]="['text-right','my-1','text-danger']" class="text-right my-1 text-danger f-12">Company Name is
                                        required</p>
                                    <p *ngIf="signupform['controls'].companyname.hasError('pattern')" class="text-danger f-12 pt-1">
                                        Special Character are not allowed!</p>
                                
                                    <mat-autocomplete #company_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'company')">
                                        <mat-option *ngFor="let company of companyName" [value]="company" [matTooltip]="company | titlecase"
                                            [matTooltipClass]="{ 'ai-tooltip text-black': true }" matTooltipPosition="above">
                                            <span class="d-flex align-items-center">
                                                <span class="text-truncate">{{company | titlecase}} </span>
                                            </span>
                                        </mat-option>
                                    </mat-autocomplete>
                                </div>

                                <div class="f-14 font-weight-400 mb-3 col-md-6"> Designation
                                    <input data-testid="auto-app-self-signup-input-4" type="text" placeholder="e.g. Software Engineer"
                                        class="wc-form-control nobg mt-1" formControlName="designation">

                                    <p *ngIf="signupform.get('designation').errors?.required && (signupform['controls'].designation.dirty || signupform['controls'].designation.touched)"
                                        [ngClass]="['text-right','my-1','text-danger']"
                                        class="text-right my-1 text-danger f-12">Designation
                                        is
                                        required</p>
                                    <p *ngIf="signupform['controls'].designation.hasError('pattern')"
                                        class="text-danger f-12 pt-1">
                                        Special Character are not allowed!</p>
                                </div>
                            </div>

                            <div class="row mr-2 mt-2">
                                <div class="col">
                                    <div class="f-14 font-weight-400 mb-3"> Work Email ID <span
                                            class="text-danger">*</span>
                                        <input data-testid="auto-app-self-signup-input-5" type="text" placeholder="Enter Work Email ID"
                                            class="wc-form-control nobg mt-1" formControlName="loginemail"
                                            [disabled]="disableEmailInput"
                                            [ngClass]="{'disabled-input': disableEmailInput}">
                                        <p *ngIf="signupform.get('loginemail').errors?.required && (signupform['controls'].loginemail.dirty || signupform['controls'].loginemail.touched)"
                                            [ngClass]="['text-right','my-1','text-danger']"
                                            class="text-right my-1 text-danger">Email ID is required
                                        </p>
                                        <p class="text-danger f-12 pt-1"
                                            *ngIf="signupform['controls'].loginemail.hasError('pattern')">
                                            Must be a valid loginemail</p>
                                    </div>
                                </div>
                            </div>

                            <div class="row mr-4 mt-2">
                                <div class="col-md-6 mb-4 position-relative">
                                    <p>Password</p>
                                    <input data-testid="auto-app-self-signup-input-6" [type]="show ? 'text' : 'password'" type="password"
                                        formControlName="password" class="wc-form-control" placeholder="Password"
                                        (click)="showpassworderror()" (focusout)="focusOut()">
                                    <span style="position: relative;"><i class="fas text-webbtree-green showpassword"
                                            [ngClass]="show ? 'fa-eye-slash' : 'fa-eye'"
                                            (click)="show=!show"></i></span>
                                    <p class="text-danger f-12 mb-0 text-right"
                                        *ngIf="signupform.controls['password'].hasError('required') && signupform.controls['password'].touched">
                                        Password is compulsory</p>
                                    <p class="text-danger f-12 mb-0 text-right"
                                        *ngIf="!signupform.controls['password'].hasError('required') && signupform.controls['password'].touched">
                                        <ng-container
                                            *ngIf="(signupform.controls['password'].hasError('required')
                                              || signupform.controls['password'].hasError('minlength')
                                              || signupform.controls['password'].hasError('hasNumber')
                                              || signupform.controls['password'].hasError('hasCapitalCase')
                                              || signupform.controls['password'].hasError('hasSmallCase')
                                              || signupform.controls['password'].hasError('hasSpecialCharacters')
                                              || signupform.controls['password'].hasError('hasKeyword')); else PasswordError">
                                            Invalid password pattern
                                        </ng-container>
                                        <ng-template #PasswordError></ng-template>
                                    </p>

                                    <div class="passwordValidMsg" *ngIf="showpassword">
                                        <label class="col f-12 d-flex"
                                            [ngClass]="signupform.controls['password'].hasError('required') || signupform.controls['password'].hasError('hasKeyword')  ? 'text-danger' : 'text-success'">
                                            <i class="material-icons f-12 mr-1">{{
                                                signupform.controls['password'].hasError('required') ||
                                                signupform.controls['password'].hasError('hasKeyword') ? 'cancel' :
                                                'check_circle' }}</i>
                                            Cannot contain reserved keywords for e.g. 'password'
                                        </label>
                                        <label class="col f-12 d-flex"
                                            [ngClass]="signupform.controls['password'].hasError('required') || signupform.controls['password'].hasError('minlength')  ? 'text-danger' : 'text-success'">
                                            <i class="material-icons f-12 mr-1">{{
                                                signupform.controls['password'].hasError('required') ||
                                                signupform.controls['password'].hasError('minlength') ? 'cancel' :
                                                'check_circle' }}</i>
                                            Must be at least 8 characters!
                                        </label>
                                        <label class="col f-12 d-flex"
                                            [ngClass]="signupform.controls['password'].hasError('required') || signupform.controls['password'].hasError('hasNumber')  ? 'text-danger' : 'text-success'">
                                            <i class="material-icons f-12 mr-1">{{
                                                signupform.controls['password'].hasError('required') ||
                                                signupform.controls['password'].hasError('hasNumber') ? 'cancel' :
                                                'check_circle' }}</i>
                                            Must contain at least 1 number!
                                        </label>
                                        <label class="col f-12 d-flex"
                                            [ngClass]="signupform.controls['password'].hasError('required') || signupform.controls['password'].hasError('hasCapitalCase')  ? 'text-danger' : 'text-success'">
                                            <i class="material-icons f-12 mr-1">{{
                                                signupform.controls['password'].hasError('required') ||
                                                signupform.controls['password'].hasError('hasCapitalCase') ? 'cancel'
                                                : 'check_circle' }}</i>
                                            Must contain at least 1 in Capital Case!
                                        </label>
                                        <label class="col f-12 d-flex"
                                            [ngClass]="signupform.controls['password'].hasError('required') || signupform.controls['password'].hasError('hasSmallCase')  ? 'text-danger' : 'text-success'">
                                            <i class="material-icons f-12 mr-1">{{
                                                signupform.controls['password'].hasError('required') ||
                                                signupform.controls['password'].hasError('hasSmallCase') ? 'cancel' :
                                                'check_circle' }}</i>
                                            Must contain at least 1 Letter in Small Case!
                                        </label>
                                        <label class="col f-12 d-flex"
                                            [ngClass]="signupform.controls['password'].hasError('required') || signupform.controls['password'].hasError('hasSpecialCharacters') ? 'text-danger' : 'text-success'">
                                            <i class="material-icons f-12 mr-1">{{
                                                signupform.controls['password'].hasError('required') ||
                                                signupform.controls['password'].hasError('hasSpecialCharacters') ?
                                                'cancel' :
                                                'check_circle' }}</i>
                                            Must contain at least 1 Special Character!
                                        </label>
                                    </div>

                                </div>
                                <div class="col-md-6 mb-4">
                                    <p>Confirm Password</p>
                                    <input data-testid="auto-app-self-signup-input-7" [type]="showConfirm ? 'text' : 'password'" class="wc-form-control"
                                        name="password" formControlName="confirmpassword" id="password"
                                        placeholder="Re-Enter Password">
                                    <span style="position: relative;"><i class="fas text-webbtree-green showpassword"
                                            [ngClass]="showConfirm ? 'fa-eye-slash' : 'fa-eye'"
                                            (click)="showConfirm=!showConfirm"></i></span>

                                    <p class="text-danger f-12 text-right mb-0"
                                        *ngIf="signupform.controls['confirmpassword'].hasError('required') && signupform.controls['confirmpassword'].touched">
                                        Password is compulsory</p>
                                    <p class="f-12 text-danger text-right mb-0"
                                        *ngIf="!signupform.controls['confirmpassword'].hasError('required') && signupform.controls['confirmpassword'].hasError('invalidpwd') && signupform.controls['confirmpassword'].touched">
                                        Password do not match.</p>
                                </div>
                            </div>

                            <div class="d-flex align-items-center mb-4 mt-1">
                                <label class="wc-checkbox mr-3 mb-0">
                                    <input data-testid="auto-app-self-signup-input-8" type="checkbox" id="mycheck" name="mycheck" formControlName="termsaccept">
                                    <i class="fas fa-check"></i>
                                </label>
                                <label class="mb-0" for="mycheck">
                                    <span class="f-2"> I agree to <a data-testid="auto-app-self-signup-a-1"
                                            href="https://www.webbtree.com/terms-and-conditions" target="_blank"
                                            tabindex="-1">
                                            Terms of Services
                                        </a> and <a data-testid="auto-app-self-signup-a-2" href="https://www.webbtree.com/privacy-policy" target="_blank"
                                            tabindex="-1">
                                            Privacy Policy
                                        </a></span>
                                </label>
                                <div
                                    *ngIf="signupform.get('termsaccept').hasError('requiredTrue') && signupform.get('termsaccept').touched">
                                    You must accept the terms and conditions.
                                </div>
                            </div>
                            <p class="text-danger f-12 pt-1" *ngIf="termsacceptError">Please Accept Terms </p>
                            <button data-testid="auto-app-self-signup-button-1" type="button" class="btn wc-btn-lg f-14 font-weight-500 bgRequestBtn mr-4"
                                data-dismiss="modal" (click)="userSignUp()" style="width: 95%;"
                                [ngClass]="!signupform.valid ? 'invalid-form' : ''">Sign Up</button>
                            <div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="card-light w-100">
                    <div class="d-flex align-items-center">
                        <span>
                            <i class="fas fa-question-circle mr-2"></i>
                        </span>
                        <div>
                            <p class="mb-1 font-weight-600">Need Assistance ?</p>
                            <p class="mb-0 text-9696 f-12">Our team will reach out to you shortly.</p>
                        </div>
                    </div>
                    <div>
                        <button data-testid="auto-app-self-signup-button-2" class="wc-ghostBtn" (click)="redirect()">
                            Contact Us
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col newebbtrreebgcolor">
            <div class="sidebanner">
                <div class="textContainer">
                    <div class="mb-3">
                        <img src="../../assets/images/newwebbtrree.png" style="width: 155px; height: auto;" alt="">
                    </div>
                    <div class="talentD">
                        Talent Discovery
                    </div>
                    <div class="beta">
                        (Hire)
                    </div>
                    <div class="sourceenrich">
                        <span>
                            Source
                        </span>
                        <i class="fas fa-circle"></i>
                        <span>
                            Nurture
                        </span>
                        <i class="fas fa-circle"></i>

                        <span>
                            Engage
                        </span>
                        <i class="fas fa-circle"></i>

                        <span>
                            Strategize
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
    <span class="successCheck"><i class="fal fa-check"></i> </span>
    <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
    <span class="errorCheck"><i class="fal fa-times"></i></span>
    <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>